import React from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, CointainerFigureImage } from '../../components/AppComponents';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { figure43 } from '../../graphs/ar/figure43';
import { figure44 } from '../../graphs/ar/figure44';
import { figure45 } from '../../graphs/ar/figure45';
import { figure48 } from '../../graphs/ar/figure48';


const Sdg6 = () => {
    return (
      
        <React.Fragment>
            <ContainerCoverVideo 
                id="6" 
                poster={require('../../images/poster-sdg-6.png').default}
                video={require('../../images/video-sdg-6.mp4').default}
                sdgImage={require('../../images/EN_06.svg').default}
                sdg="الهدف 6 من أهداف التنمية المستدامة"
                title="المياه النظيفة والصرف الصحي"
                subtitle="ضمان توفر المياه وخدمات الصرف الصحيللجميع وإدارتها على نحو مستدام"
                summaryTable={require('../../images/Goal_6.zip').default}
                indicators={['6.4.1', '6.4.2']}  
                indicatorsTitle="المؤشرات"
                summaryTableTitle= "(باللغة الإنجليزية) الخُمس الخامس"
            />

<Container>
                <TitleSub title="نظرة عامة" />
<p>لا يزال مليارات الأشخاص يفتقرون إلى المياه المأمونة والصرف الصحي والنظافة الصحية. في حين كان هناك تحسن في توفير هذه الخدمات الأساسية، لا يزال هناك الكثير الذي يتعين القيام به لتحقيق الهدف 6 من أهداف التنمية المستدامة. تعد ندرة المياه مشكلة متنامية في أجزاء كثيرة من العالم، وتؤدي النزاعات وتغير المناخ إلى تفاقم المشكلة. بالإضافة إلى ذلك، تواجه البلدان تحديات متزايدة مرتبطة بالنظم الإيكولوجية المتدهورة المتعلقة بالمياه، وندرة المياه الناجمة عن تغير المناخ، ونقص الاستثمار في المياه والصرف الصحي، وعدم كفاية التعاون بشأن المياه العابرة للحدود. سيتطلب تحقيق التغطية الشاملة بحلول عام 2030 زيادة ستة أضعاف في المعدلات العالمية الحالية للتقدم في مياه الشرب، وزيادة خمسة أضعاف في الصرف الصحي، وزيادة ثمانية أضعاف في النظافة.</p>
<p>على المستوى العالمي، لا تزال مستويات الإجهاد المائي عند مستوى آمن يبلغ 18.2 في المائة في عام 2020. ومع ذلك، فإن هذا يخفي اختلافات إقليمية كبيرة حيث يواجه عدد من المناطق مستويات عالية أو حتى حرجة من الإجهاد المائي، والتي تفاقمت في بعض الحالات خلال السنوات الأخيرة. وفي الوقت نفسه، ارتفعت كفاءة استخدام المياه من 17.4 دولارًا أمريكيًا لكل متر<sup>مكعب</sup> في عام 2015 إلى 18.9 دولارًا أمريكيًا لكل<sup>متر مكعب</sup> في جميع أنحاء العالم في عام 2020.</p>
 <div id="section6.4.1">
                  <HeaderSdg 
                      title="مؤشر أهداف التنمية المستدامة 6.4.1"
                        subtitle="التغير في كفاءة استخدام المياه بمرور الوقت"
                      badges={[
                          {color: '#FFFF00', text: 'تقييم الحالة العالمية: في متوسط القيم القطرية تقييم الاتجاه'},
                          { color: '#00a700', text: 'العالمي: التحسن'},
                      ]}
                      target={{
                          sdg: "6",
                          title: 'الهدف 6.4',
                          text: 'بحلول عام 2030، زيادة كفاءة استخدام المياه بشكل كبير في جميع القطاعات وضمان السحب المستدام وإمدادات المياه العذبة لمعالجة ندرة المياه والحد بشكل كبير من عدد الأشخاص الذين يعانون من ندرة المياه.'
                      }}
                  />
                </div>
<p><i>بعد زيادة مطردة وتدريجية من 2015 إلى 2019، شهدت كفاءة استخدام المياه انخفاضًا من 2019 إلى 2020 في جميع أنحاء العالم</i></p>
<p>ارتفعت كفاءة استخدام المياه (WUE) من 17.4 دولارًا أمريكيًا/م<sup>3</sup> في عام 2015 إلى 18.9 دولارًا أمريكيًا/م<sup>3</sup> في عام 2020 في جميع أنحاء العالم، وهو ما يمثل زيادة في الكفاءة بنسبة 9 في المائة (Figure 43). ومع ذلك، فإن هذا يمثل انخفاضًا طفيفًا عن العام السابق، عندما بلغت WUE ذروتها عند 19.4 في المائة. في عام 2020، تراوحت تقديرات WUE بين أقل من 3 دولارات أمريكية/م<sup>3</sup> في الاقتصادات التي تعتمد إلى حد كبير على الزراعة وأكثر من 50 دولارًا أمريكيًا/م<sup>3</sup> في الاقتصادات الصناعية العالية القائمة على الخدمات. يشير هذا إلى أن الهيكل الاقتصادي للبلد له صلة مباشرة بمستويات الكفاءة الإجمالية لاستخدام المياه. قدم حوالي 57 في المائة من البلدان كفاءة في استخدام المياه تعادل 20 دولارًا أمريكيًا/م<sup>3</sup> أو أقل في عام 2020، مقارنة بـ 58 في المائة في عام 2015(Figure 44). ومع ذلك، تخفي القيم العالمية الاختلافات الإقليمية.( Figure 45). تُظهر وسط وجنوب آسيا وشرق آسيا وجنوب شرق آسيا وأوقيانوسيا أعلى معدلات النمو في غرب أوروبا من عام 2015 إلى عام 2020، في حين تُظهر أمريكا اللاتينية ومنطقة البحر الكاريبي انخفاضًا. </p>
<p>شهدت جميع القطاعات الاقتصادية زيادة في كفاءة استخدام المياه منذ عام 2015. في عام 2020، كان لدى القطاع الصناعي ما يعادل 32.08 دولارًا أمريكيًا/م<sup>3</sup>، وقطاع الخدمات 104.65 دولارًا أمريكيًا/م<sup>3</sup> ، وقطاع الزراعة 0.59 دولارًا أمريكيًا/م<sup>3</sup>. من الناحية النسبية، شهدت كفاءة استخدام المياه في الزراعة أكبر زيادة (20 في المائة) عن عام 2015، مقارنة بالقطاع الصناعي (13 في المائة) وقطاع الخدمات (0.3 في المائة)(Table 2).</p>
<p>تعد زيادة إنتاجية المياه الزراعية (كمية أو قيمة الإنتاج فيما يتعلق بكمية المياه المستهلكة بشكل مفيد) من خلال أنظمة ري أكثر كفاءة وممارسات إدارة زراعية أفضل أمرًا أساسيًا لتحسين كفاءة استخدام المياه، لا سيما في البلدان التي تعتمد على الزراعة. وتشمل الاستراتيجيات الهامة الأخرى لزيادة الكفاءة العامة للمياه الحد من خسائر المياه، مثل معالجة التسربات في شبكات التوزيع البلدية وتحسين عمليات التبريد الصناعية وتبريد الطاقة.</p>
</Container>
<ContainerChart
                title="الشكل43. كفاءة استخدام المياه العالمية، دولار أمريكي/مترمكعب (2015–2020)"
                legend={[
                    
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure43}
                />
</ContainerChart>
<ContainerChart
                title="الشكل 44. حصة البلدان حسب فئات كفاءة استخدام المياه (2015 و2020)"
                legend={[
                    {title: '2015', color: '#00b0f0'},
                    {title: '2020', color: '#b4c7e7'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure44}
                />
</ContainerChart>
<ContainerChart
                title="الشكل45. التغير في كفاءة استخدام المياه حسب المنطقة، حسب الدولار الأمريكي/متر مكعب (2015–2020)"
                legend={[
                    { title: 'آسيا الوسطى وجنوب آسيا', color: '#5b9bd6', customCSSClass: 'half-width' },
                    { title: 'أمريكا الشمالية وأوروبا ', color: '#ed7e31', customCSSClass: 'half-width' },
                    { title: 'غرب آسيا وشمال أفريقيا', color: '#a6a5a4', customCSSClass: 'half-width' },
                    { title: 'أفريقيا جنوب الصحراء', color: '#ffbf00', customCSSClass: 'half-width' },
                    { title: 'أمريكا اللاتينية ومنطقة البحر الكاريبي', color: '#4372c4', customCSSClass: 'half-width' },
                    { title: 'أوقيانوسيا', color: '#71ad49', customCSSClass: 'half-width' },
                    { title: 'شرق آسيا وجنوب شرق آسيا', color: '#265e91', customCSSClass: 'half-width' },
                    { title: 'العالم', color: '#9e480e', customCSSClass: 'half-width' }
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig45" download>https://doi.org/10.4060/CC7088EN-fig45</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure45}
                />
</ContainerChart>
<Container>
<p className="text-center mb-0"><span><i>الجدول 2. كفاءة استخدام المياه عبر القطاعات (2015 و2020)</i></span></p>
<table className="annex-table text-center">
<thead>
<tr>
<th className="text-center">كفاءة استخدام المياه القطاعية (WUE)</th>
<th className="text-center">2015</th>
<th className="text-center">2020</th>
<th className="text-center">التغيير 2015–2020 (النسبة المئوية)</th>
</tr>
</thead>
<tbody>
<tr>
<td className="text-right">كفاءة استخدام المياه القطاعية في الزراعة (دولار أمريكي/م<sup className="font-weight-normal">3</sup>)</td>
<td className="text-right">0.49</td>
<td className="text-right">0.59</td>
<td className="text-right">20.4</td>
</tr>
<tr>
<td className="text-right">كفاءة استخدام المياه القطاعية في الصناعة (دولار أمريكي/م<sup className="font-weight-normal">3</sup>)</td>
<td className="text-right">28.37</td>
<td className="text-right">32.08</td>
<td className="text-right">13.1</td>
</tr>
<tr>
<td className="text-right">كفاءة استخدام المياه القطاعية في الخدمات (دولار أمريكي/م<sup className="font-weight-normal">3</sup>)</td>
<td className="text-right">104.3</td>
<td className="text-right">104.65</td>
<td className="text-right">0.3</td>
</tr>
</tbody>
</table>
<p className="note text-center"><i>المصدر</i>: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></p>
</Container>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 46. الوضع الحالي لكفاءة استخدام المياه، حسب الخُمس (2020)"
                legend={[
                    {title: 'الخُمس الخامس', color: '#00a700'},
                    {title: 'الخُمس الرابع', color: '#2acb2a'},
		    {title: 'الخُمس الثالث', color: '#ffff05'},
		    {title: 'الخُمس الثاني', color: '#ffa500'},
		    {title: 'الخُمس الأول', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/></span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map46' src="fig46.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 47. الاتجاه في كفاءة استخدام المياه (2015–2020)"
                legend={[
                    {title: 'التحسين', color: '#00a700'},
                    {title: 'تحسّن طفيف', color: '#2acb2a'},
		    {title: 'لا يوجد تحسن', color: '#ffff05'},
		    {title: 'تدهور طفيف	', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span> المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/> </span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map47' src="fig47.html" width='100%'  height='500px'/>

            </ContainerChart>
        <Container>
                <div id="section6.4.2">
                    <HeaderSdg 
                        title="مؤشر أهداف التنمية المستدامة 6.4.2"
                        subtitle="مستوى الإجهاد المائي: سحب المياه العذبة كنسبة من موارد المياه العذبة المتاحة"
                        badges={[
                            {color: '#cecece', text: 'تقييم التقدم العالمي: لم يتم إجراء تقييم على المستوى العالمي لأن قيمة المؤشر العالمي أقل من 25 في المائة'},
                            {/*{ color: '#cecece', text: 'Global trend assessment: '},*/}
                        ]}
                        target={{
                            sdg: "6",
                            title: 'الهدف 6.4',
                            text: 'بحلول عام 2030، زيادة كفاءة استخدام المياه بشكل كبير في جميع القطاعات وضمان السحب المستدام وإمدادات المياه العذبة لمعالجة ندرة المياه والحد بشكل كبير من عدد الأشخاص الذين يعانون من ندرة المياه.'
                        }}
                    />
                </div>

<p><i>ظل الإجهاد المائي على مستوى العالم، على الرغم من الزيادة الطفيفة بمقدار 0.2 نقطة مئوية منذ عام 2015، عند مستوى آمن بلغ 18.2 في المائة في عام 2020، ولكن مع وجود اختلافات إقليمية كبيرة.</i></p>
<p>يمثل مقياس الإجهاد المائي جميع عمليات سحب المياه العذبة بالنسبة إلى إجمالي موارد المياه العذبة، بما في ذلك متطلبات التدفق البيئي لخدمات النظام الإيكولوجي. يمثل معدل السحب الذي يزيد عن 75 في المائة من موارد المياه المتجددة إجهادًا مائيًا مرتفعًا، وأكثر من 100 في المائة أمر بالغ الأهمية. يمكن أن يكون للإجهاد المائي المرتفع عواقب وخيمة على البيئة ويعيق التنمية الاقتصادية والاجتماعية أو حتى يعكس اتجاهها.</p>
<p>على المستوى العالمي، لا يزال الإجهاد المائي عند مستوى آمن يبلغ 18.2 في المائة في عام 2020. ومع ذلك، فإن هذا يخفي اختلافات إقليمية كبيرة، ويمثل ارتفاعًا بنسبة 1.2 في المائة منذ عام 2015. في عام 2020، تراوحت مستويات الإجهاد المائي من عالية في جنوب آسيا وآسيا الوسطى إلى حرجة في شمال أفريقيا. الوضع في شمال إفريقيا مثير للقلق بشكل خاص، لأنه ليس فقط المنطقة دون الإقليمية الوحيدة التي سجلت مستوى حرجًا من الإجهاد المائي أكثر من 100 في المائة (مما يعني أنه يتم سحب المزيد من المياه العذبة مع توفر موارد المياه العذبة المتجددة) ؛ كما سجلت زيادة مثيرة للقلق بمقدار 15 نقطة مئوية في مستويات الإجهاد المائي بين عامي 2015 و2020.</p>
<p>على الصعيد العالمي، تعد الزراعة القطاع المهيمن من حيث سحب المياه العذبة، حيث تمثل 72 في المائة من إجمالي سحب المياه العذبة في عام 2020، يليها القطاع الصناعي بنسبة 16 في المائة وقطاع الخدمات بنسبة 12 في المائة من إجمالي سحب المياه العذبة. ظلت حصص مساهمة القطاعات الثلاثة في الإجهاد المائي مستقرة إلى حد ما منذ عام 2015 (انظر Table 3 أدناه).</p>
	</Container>
<ContainerChart
                title="الشكل 48. مستوى الإجهاد المائي حسب المنطقة الجغرافية والمنطقة دون الإقليمية (2015 و2020)"
                legend={[
                    {title: '2015', color: '#deebf7'},
                    {title: '2020', color: '#00b0f0'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig48" download>https://doi.org/10.4060/CC7088EN-fig48</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure48}
                />
</ContainerChart>

<Container>
<p className="text-center mb-0"><span><i>الجدول 3. حصة مستوى الإجهاد المائي حسب القطاع</i></span></p>
<table className="annex-table text-center" dir="rtl">
<thead>
<tr>
<th className="text-right">مساهمة القطاعات المختلفة في مستوى الإجهاد المائي </th>
<th className="text-right">2015</th>
<th className="text-right">2020</th>
</tr>
</thead>
<tbody>
<tr>
<td className="text-right">الزراعة </td>
<td className="text-right">13.0</td>
<td className="text-right">13.1</td>
</tr>
<tr>
<td className="text-right">الصناعة </td>
<td className="text-right">2.9</td>
<td className="text-right">2.8</td>
</tr>
<tr>
<td className="text-right">الخدمات </td>
<td className="text-right">2.1</td>
<td className="text-right">2.4</td>
</tr>
<tr>
<td className="text-right">الاقتصاد العام</td>
<td className="text-right">18.0</td>
<td className="text-right">18.2</td>
</tr>
</tbody>
</table>
<p>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></p>
</Container>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 49. الوضع الحالي لمستوى الإجهاد المائي العالمي (2020)"
                legend={[
                    {title: 'حرج: >100%', color: '#00441b'},
                    {title: 'مرتفع (75%-100%]', color: '#006d2c'},
		    {title: 'متوسط (50%-75%]', color: '#238b45'},
		    {title: 'منخفض (25%-50%]', color: '#41ab5d'},
		    {title: 'لا يوجد إجهاد [0%-25%]', color: '#f0fff0'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map49' src="fig49.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 50. اتجاه تقدم البلدان نحو ضمان السحب المستدام للمياه العذبة (2015–2020)"
                legend={[
                    {title: 'التحسين', color: '#00a700'},
                    {title: 'تحسّن طفيف', color: '#2acb2a'},
		    {title: 'لا يوجد تحسن', color: '#ffff05'},
		    {title: 'تدهور طفيف', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'هدف التنمية المستدامة 6.4.2 <= 25%', color: '#f0fff0'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map50' src="fig50.html" width='100%'  height='500px'/>

            </ContainerChart>
        </React.Fragment>
    ) 
}


export default Sdg6;
